import { html, render } from 'lit-html';
import CtvDialogBase from './dialog-base'
import "./dialog-modal.scss";
import BrowsersWhitelist from "@camtv/front-base-lib/utilities/browser-whitelist";
import CtvButton from './button';


export default class CtvDialogModal extends CtvDialogBase {

	//Add translations
	GetTranslations() {
		return {
			"Indietro": {
				"it": "Indietro",
				"en": "Back"
			}
		}
	}

	static get properties() {
		return {

			body: { type: Object },
			show_help_link: { type: String },
			show_back_link: { type: String },
			help_mode: { type: String },

			title_label: { type: String },
			footer_left_link_label: { type: String },
			footer_right_link_label: { type: String },
			footer_button_label: { type: String },
			footer_left_link_disabled: { type: Boolean }
		};
	}

	constructor() {
		super();

		this.title_label = "";
		this.body = null;
		this.show_help_link = false;
		this.show_back_link = false;

		this.footer_left_link_label = "";
		this.footer_right_link_label = "";
		this.footer_button_label = "";

		this.footer_left_link_disabled = false;

		this.footer_left_link_handler = null;
		this.footer_right_link_handler = null;
		this.footer_button_handler = null;

		this.help_mode = false;

		this.waiter = null;
		this.classModifier = "modal";

		BrowsersWhitelist.GetBroswerProps(); //BUG-1738 fix UIA57-80
	}

	updated(updatedProperties) {

		if (updatedProperties.has("body")) {
			let elBody = this.querySelector(".ctv-dialog-body");
			this.RenderObject(this.body, elBody)
		}

		if (updatedProperties.has("help_mode")) {
			if (this.body != null && this.body.OnHelpModeChanged != null)
				this.body.OnHelpModeChanged(Types.ToBool(this.help_mode))
		}


		// if (this.OnOK!=null) {
		// 	if (this.OnOK.constructor.name == 'AsyncFunction')
		// 		await this.OnOK(evt)
		// 	else
		// 		this.OnOK(evt)
		// }		
	}

	async Init() {
		document.querySelector('body').classList.add('no-scroll');
	}

	async UnInit() {
		if (CtvDialogBase.DialogsStack.length == 0) {
			document.querySelector('body').classList.remove('no-scroll');
		}
	}

	GetCurrentModule() {
		return this.body;
	}

	async ShowModule(elModule) {
		if (this.body != elModule) {
			if (this.body != null && this.body.OnHide != null)
				if (await this.body.OnHide() === false)
					return;

			this.footer_left_link_handler = null;
			this.footer_right_link_handler = null;
			this.footer_button_handler = null;
			this.body = elModule;

			let body = this.querySelector(".ctv-dialog-body")
			if (body != null) {
				body.scrollTop = 0;
			}


			setTimeout(async () => {
				if (elModule != null && elModule.OnShow != null)
					if (await elModule.OnShow())
						return;
			}, 1);
		}
	}

	SetLeftLink(Label, ClickHandler) {
		this.footer_left_link_label = Label;
		this.footer_left_link_handler = ClickHandler;
	}

	SetRightLink(Label, ClickHandler) {
		this.footer_right_link_label = Label;
		this.footer_right_link_handler = ClickHandler;
	}

	SetButton(Label, ClickHandler) {
		this.footer_button_label = Label;
		this.footer_button_handler = ClickHandler;
	}

	RenderHeader() {

		return html`
			<div class="arrow-container arrow-back">
				${BrowsersWhitelist.IsMobile == true || Types.ToBool(this.show_back_link) == true ? html`
					<a href="#" @click="${this.OnBackLinkClicked}" class="back">
						<i>
							<svg viewBox="0 0 24 24">
								<path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
							</svg>
						</i>
						<span>${this.Ln("Indietro")}</span>
					</a>
					<a href="#" @click="${this.OnBackLinkClicked}" class="close">
						<i>
							<svg viewBox="0 0 24 24">
								<path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
							</svg>
						</i>
					</a>
				`: ``}
			</div>
			<div class="title">
				${this.ToHtml(this.title_label)}
			</div>
			<div class="help-container">
				${Types.ToBool(this.show_help_link) == true ? html`<span class="help" @click=${this.OnHelpLinkClicked}>?</span>` : ``}
			</div>
		`;
	}

	RenderBody() {

	}

	RenderFooter() {

		return html`
		<div>
			${Types.ToString(this.footer_left_link_label) != "" ? html`
				<a
					href="#"
					@click="${this.OnLeftLinkClicked}"
					?disabled="${this.footer_left_link_disabled}">
					${this.ToHtml(this.footer_left_link_label)}
				</a>
				`: ``
			}
		</div>
		<div>
			${Types.ToString(this.footer_right_link_label) != "" ? html`
				<a href="#" @click="${this.OnRightLinkClicked}">
					${this.ToHtml(this.footer_right_link_label)}
				</a>
				`: ``
			}
			${Types.ToString(this.footer_button_label) != "" ? html`
				${this.RenderButton()}
				`: ``
			}
		</div>
		`;
	}

	RenderButton() {
		return html`<ctv-button @click="${this.OnButtonClicked}" label="${this.footer_button_label}"></ctv-button>`
	}

	async CanClose() {

		if (this.body != null && this.body.CanClose != null)
			if (await this.body.CanClose() != true)
				return;

		return super.CanClose();
	}

	async Ok() {

		if (this.body != null && this.body.OnHide != null)
			if (await this.body.OnHide() === false)
				return;

		return super.Ok();
	}

	async Cancel() {

		if (this.body != null && this.body.CanClose != null)
			if (await this.body.OnHide() === false)
				return;

		return super.Cancel();
	}

	async OnBackLinkClicked(evt) {
		evt.preventDefault();

		if (this.body != null && this.body.OnBack != null)
			await this.body.OnBackLinkClicked(evt);
		else
			window.history.back();
	}

	async OnHelpLinkClicked(evt) {
		evt.preventDefault();
		if (Types.ToBool(this.help_mode) == true)
			this.help_mode = false;
		else
			this.help_mode = true;
	}

	async OnLeftLinkClicked(evt) {
		evt.preventDefault();

		if (this.footer_left_link_handler != null)
			await this.footer_left_link_handler(evt);
	}

	async OnRightLinkClicked(evt) {
		evt.preventDefault();

		if (this.footer_right_link_handler != null)
			await this.footer_right_link_handler(evt);

	}

	async OnButtonClicked(evt) {
		evt.preventDefault();

		if (this.footer_button_handler != null)
			await this.footer_button_handler(evt);
	}

	Show() {
		return CtvDialogBase.Show(this);
	}
}
